import axiosInstance from "../../api/axiosInstance";

export const fetchUserRegistrationStatsAPI = async ({
  year,
  section,
  forceRefresh,
} = {}) => {
  const params = new URLSearchParams();

  if (year) params.set("year", String(year));
  if (section) params.set("section", String(section));
  if (forceRefresh) params.set("forceRefresh", "true");

  const response = await axiosInstance.get(
    `users/registration-stats?${params.toString()}`,
  );

  return response.data;
};

export const fetchActiveUsersComparisonStatsAPI = async ({ timeframe } = {}) => {
  const params = new URLSearchParams();

  if (timeframe) params.set("timeframe", String(timeframe));

  const response = await axiosInstance.get(
    `users/active-users-comparison-stats?${params.toString()}`,
  );

  return response.data;
};

export const fetchUsersSinceDateStatsAPI = async ({ fromDate } = {}) => {
  const params = new URLSearchParams();

  if (fromDate) params.set("fromDate", String(fromDate));

  const response = await axiosInstance.get(
    `users/users-since-date-stats?${params.toString()}`,
  );

  return response.data;
};

export const fetchTournamentRegistrationAnalyticsAPI = async ({
  tournamentId,
} = {}) => {
  const params = new URLSearchParams();

  if (tournamentId) params.set("tournamentId", String(tournamentId));

  const response = await axiosInstance.get(
    `users/tournament-registration-analytics?${params.toString()}`,
  );

  return response.data;
};
